import { IGetComparisonDesktopResponseSchema } from 'shared/repositories/offers-comparison/entities/get_comparison_desktop/GetComparisonDesktopResponseSchema';

import { IAppState } from '../common/state';

export const selectComparisonOffers = (state: IAppState): IGetComparisonDesktopResponseSchema | null => {
  return state.comparison;
};
